import { unionFiles } from '@/utils/utils'
import { setFileUser } from '@/http/user/userApi'

export class FilesService {
  async sendFiles (data, userId, { files, nameList }) {
    unionFiles(files, nameList, data)
    return await setFileUser(userId, data)
  }
}
